
$(document).ready(function() {
  var location_pop = $('.location__overlay');

  $('.location__us').click(function() {
    document.cookie = "ALBEK=U";
    
    location_pop.removeClass('overlay__open');
  });
      
  $('.location__eu').click(function() {
    document.cookie = "ALBEK=E";
    window.location.href = 'https://albek.eu';
  });
      
  $('.location__au').click(function() {
    document.cookie = "ALBEK=A";
    window.location.href = 'https://albek.com.au';
  });


  $.ajax({
    url: "https://geolocation-db.com/jsonp",
    jsonpCallback: "callback",
    dataType: "jsonp",
    success: function( location ) {
      var locations = ["United States", "Canada"];
      console.log(location.country_name);
    
      if ($.inArray(location.country_name, locations) !== -1) {
        console.log('User in Americas')
      }
      else{
        if (document.cookie.split(';').some((item) => item.includes('ALBEK=U'))) {
      
        }
        else {
          location_pop.addClass('overlay__open');
        }
      }
    }
  });
});